(() => {
'use strict';
const norm = s => String(s || '').toUpperCase().replace(/\s+/g, '');
const canonical = s => String(s || '').trim().replace(/\s+/g,' ').replace(/(^|[^\d])\.(\d)/g,'$10.$2');
const fields = {
thickness: [['brand','Brand'],['readout','Thickness Gauge Selection'],['description','Type'],['units','Units'],['range','Range'],['throat','Throat Depth'],['resolution','Resolution'],['accuracy','Accuracy'],['force','Force']],
snap: [['brand','Brand'],['range','Range'],['parallelism','Parallelism'],['force','Force'],['indicator','Indicator Supplied']],
depth: [['readout','Depth Gauge Selection'],['brand','Brand'],['units','Units'],['range','Range'],['base','Base Size'],['resolution','Resolution'],['accuracy','Accuracy'],['force','Force'],['stroke','Stroke']]
};
const title = {thickness:'Thickness Gauges',snap:'Dial Snap Gauges',depth:'Depth Gauges'};
const units = r => {
const s = r.range + ' ' + (r.resolution || '');
const metric = /mm/i.test(s), inch = /"|inch/i.test(s);
return metric && inch ? 'Inch/Metric' : metric ? 'Metric' : inch ? 'Inch' : '';
};
const rangeNumber = r => {
const s = String(r.range || '').replace(/\s/g,'');
const a = [...s.matchAll(/\d*\.?\d+/g)].map(m=>Number(m[0]));
return a.length ? a[Math.min(1,a.length-1)] * (r.units==='Inch' ? 25.4 : 1) : 0;
};
function automaticSpec(variant,t,family) {
const d=t.dataset,titleText=String(d.title||''),text=titleText+' '+String(d.productType||''),sku=norm(variant.sku);
if(/\b(accessor\w*|replacement|spare|cables?|holders?|stands?|calibration|feeler|leaves|ultrasonic|coating)\b|contact\s+point|ultra\s+sonic|copper\s+foil/i.test(text))return null;
const readoutText=text+' '+String(d.sourceReadout||'');
let readout=/\bdigital\b|digimatic|quick\s*mini/i.test(readoutText)?'Digital':/\bdial\b|analogu?e|analog/i.test(readoutText)?'Dial':'Not specified';
let detected='';
if(/thickness\s+gau?ges?/i.test(text) && !/\bmicrometer\b|snap\s+gau?ge/i.test(titleText))detected='thickness';
else if(/dial\s+snap|snap\s+meters?|snap\s+gau?ges?/i.test(text) && readout!=='Digital'){detected='snap';readout='Dial';}
else if(/depth\s+gau?ge/i.test(text) && !/micrometer|caliper|tyre|tire/i.test(text) && !/^(527-|571-)/.test(sku) && (/^(547-|72\d\d|3540-)/.test(sku) || readout==='Dial'))detected='depth';
if(detected!==family)return null;
const r={sku:variant.sku,family:detected,readout,brand:d.vendor||'',description:'Standard',range:'',throat:'',resolution:'',accuracy:'',force:'',base:'',stroke:'',parallelism:'',indicator:''};
for(const field of ['range','throat','resolution','accuracy','force','base','stroke','parallelism','indicator'])r[field]=canonical(d['source'+field[0].toUpperCase()+field.slice(1)]||'');
const range=titleText.match(/(\d*[.,]?\d+\s*[-–]\s*\d*[.,]?\d+\s*(?:mm|inch|["″]))/i);
if(!r.range && range)r.range=canonical(range[1].replace(',','.'));
const step=titleText.match(/(?:graduation|resolution|digital step)\s*[:=]?\s*(\d*[.,]?\d+\s*(?:mm|inch|["″]))/i);
if(!r.resolution && step)r.resolution=canonical(step[1].replace(',','.'));
const printedStep=titleText.match(/(?:mm|inch|["″])\s*[,;x]\s*(\d*[.,]?\d+\s*(?:mm|inch|["″]))/i);
if(!r.resolution && printedStep)r.resolution=canonical(printedStep[1].replace(',','.'));
const details=String(d.productDescription||'')+' '+String(d.productTechnical||'');
const detailStep=details.match(/(?:graduation|resolution|reading)\s*[:=]?\s*(\d*[.,]?\d+\s*(?:mm|inch|["″]))/i);
if(!r.resolution && detailStep)r.resolution=canonical(detailStep[1].replace(',','.'));
const accuracy=details.match(/accuracy\s*[:=]?\s*((?:±|\+\/?-)\s*\d*[.,]?\d+\s*(?:mm|inch|["″]))/i);
if(!r.accuracy && accuracy)r.accuracy=canonical(accuracy[1].replace(',','.'));
const throat=titleText.match(/(?:throat(?: depth)?\s*[:=]?\s*(\d*[.,]?\d+\s*(?:mm|inch|["″]))|(\d*[.,]?\d+\s*(?:mm|inch|["″]))\s*throat)/i);
if(!r.throat && throat)r.throat=canonical(throat[1]||throat[2]);
r.description=/ceramic/i.test(titleText)?'Ceramic Anvils':/\blens\b/i.test(titleText)?'Lens Thickness':/\bblade\b/i.test(titleText)?'Blade Anvils':/\broller\b/i.test(titleText)?'Roller Anvils':/\bpipe\b|\btube\b/i.test(titleText)?'Tube Thickness':/deep\s+throat/i.test(titleText)?'Deep Throat':/\bpocket\b|quick\s*mini/i.test(titleText)?'Pocket / Mini':'Standard';
if(detected==='snap' && /without indicator|indicator not supplied/i.test(titleText))r.indicator='Not Supplied';
return r;
}
async function getText(url) {
const controller = new AbortController();
const timer = setTimeout(()=>controller.abort(),45000);
try { const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
if (!response.ok) throw new Error('Unable to load gauge data');
return await response.text(); } finally {clearTimeout(timer);}
}
async function init(host) {
const family = host.dataset.family;
const previewId=new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role==='main'?'':host.dataset.theme);
const find = selector => host.querySelector(selector);
const status=find('[data-mqsg-status]'),grid=find('[data-mqsg-grid]'),filters=find('[data-mqsg-filters]'),count=find('[data-mqsg-count]'),pagination=find('[data-mqsg-page]'),retry=find('[data-mqsg-retry]'),sort=find('[data-mqsg-sort]');
find('[data-mqsg-heading]').textContent = (host.dataset.readout && family!=='snap' ? host.dataset.readout+' ' : '') + title[family];
let selected = {readout:host.dataset.readout || ''}, all=[], page=1, running=false;
const controls=new Map();
function matches(r,skip) {return Object.entries(selected).every(([k,v])=>!v || k===skip || r[k]===v);}
function renderFilters() {
filters.replaceChildren();controls.clear();
for (const [key,baseLabel] of fields[family]) {
const readout=selected.readout;
if(key==='stroke' && readout==='Digital') continue;
if(key==='resolution' && !readout && family!=='snap') {
addControl(key,'Resolution / Graduation');
} else addControl(key,key==='resolution' && readout==='Dial' ? 'Graduation' : baseLabel);
}
function addControl(key,labelText) {
const vals=[...new Set(all.filter(r=>matches(r,key)).map(r=>r[key]).filter(Boolean))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
if(!vals.length && !selected[key]) return;
const label=document.createElement('label');label.className='mqsm__field';label.textContent=labelText;
const select=document.createElement('select');select.dataset.mqsgFilter=key;
select.add(new Option(key==='readout'?'Digital & Dial':'All '+labelText.toLowerCase(),''));
for(const v of vals) select.add(new Option(v,v));
if(selected[key] && !vals.includes(selected[key])) select.add(new Option(selected[key],selected[key]));
select.value=selected[key] || '';controls.set(key,select);
select.addEventListener('change',()=>{
selected[key]=select.value;
if(key==='readout') for(const k of Object.keys(selected)) if(k!=='readout') delete selected[k];
page=1;render();});label.append(select);filters.append(label);
}
const clear=document.createElement('button');clear.type='button';clear.className='mqsm__reset';clear.textContent='Clear filters';
clear.addEventListener('click',()=>{selected={readout:host.dataset.readout || ''};page=1;render();});filters.append(clear);
}
function render() {
find('[data-mqsg-heading]').textContent=(selected.readout && family!=='snap' ? selected.readout+' ' : '')+title[family];
renderFilters();
const rows=all.filter(r=>matches(r));
const by=sort.value;
rows.sort((a,b)=>by==='price'?a.price-b.price:by==='price-desc'?b.price-a.price:by==='range'?rangeNumber(a)-rangeNumber(b):by==='range-desc'?rangeNumber(b)-rangeNumber(a):String(a[by]||'').localeCompare(String(b[by]||''),undefined,{numeric:true}));
const pages=Math.max(1,Math.ceil(rows.length/48));page=Math.min(page,pages);
count.textContent=rows.length+' gauge'+(rows.length===1?'':'s');grid.replaceChildren();
for(const r of rows.slice((page-1)*48,page*48)) {
const content=r.template.content.cloneNode(true);
const sku=content.querySelector('.mqsm-card__sku');if(sku)sku.textContent='SKU: '+r.sku;
const formatter=new Intl.NumberFormat('en-GB',{style:'currency',currency:host.dataset.currency || 'EUR'});
const price=content.querySelector('.mqsm-card__price');if(price && r.price>0)price.textContent=formatter.format(r.price/100);
const from=content.querySelector('.mqsm-card__from');if(from)from.remove();
const compare=content.querySelector('.mqsm-card__compare');if(compare) {if(r.comparePrice>r.price)compare.textContent=formatter.format(r.comparePrice/100);else compare.remove();}
const info=document.createElement('p');info.className='mqsg__spec';
info.textContent=fields[family].filter(([k])=>!['brand','readout','description','units'].includes(k) && r[k]).map(([k,label])=>(k==='resolution' && r.readout==='Dial'?'Graduation':label)+': '+r[k]).join(' · ');
const body=content.querySelector('.mqsm-card__body');if(body)body.insertBefore(info,body.querySelector('.mqsm-card__pricing'));
if(r.variantId) for(const link of content.querySelectorAll('a[href]')) {const url=new URL(link.href,location.origin);url.searchParams.set('variant',r.variantId);link.href=url.toString();}
grid.append(content);
}
if(!rows.length) {const message=document.createElement('p');message.textContent='No gauges match these filters. Clear filters to see all available gauges.';grid.append(message);}
pagination.replaceChildren();if(pages>1) {
const prev=document.createElement('button'),next=document.createElement('button'),label=document.createElement('span');
prev.type=next.type='button';prev.textContent='Previous';next.textContent='Next';prev.disabled=page===1;next.disabled=page===pages;label.textContent='Page '+page+' of '+pages;
prev.onclick=()=>{page--;render();};next.onclick=()=>{page++;render();};pagination.append(prev,label,next);
}
}
async function load() {
if(running)return;running=true;retry.hidden=true;filters.hidden=true;status.hidden=false;status.textContent='Loading '+title[family].toLowerCase()+'…';
try {
const master=JSON.parse(await getText(host.dataset.master)).filter(r=>r.family===family);
for(const r of master) {for(const k of ['range','throat','resolution','accuracy','parallelism','force','base','stroke']) if(r[k])r[k]=canonical(r[k]);r.units=units(r);}
const map=new Map(master.map(r=>[norm(r.sku),r])),found=new Map();
async function fetchPage(query,p,manual=false,groupCollection=false,productType='') {
const url=new URL(productType?(window.Shopify?.routes?.root||'/')+'collections/types':groupCollection?host.dataset.groups:host.dataset.search,location.origin);url.searchParams.set('q',productType|| (manual?'tag:mqs-gauge-filter':query));
if(previewId)url.searchParams.set('preview_theme_id',previewId);url.searchParams.set('type','product');url.searchParams.set('view','mqs-special-gauge-data');url.searchParams.set('options[prefix]','none');url.searchParams.set('options[unavailable_products]','show');url.searchParams.set('page',p);if(productType){url.searchParams.delete('type');url.searchParams.set('sort_by','title-ascending');}
const doc=new DOMParser().parseFromString(await getText(url),'text/html'),feed=doc.querySelector('[data-mqsg-feed]');
if(!feed)throw new Error('Gauge data view is unavailable');
for(const t of feed.querySelectorAll('[data-mqsg-record]')) {
const variants=JSON.parse(t.dataset.variants || '[]');
for(const variant of variants) {
const key=norm(variant.sku)||t.dataset.id+':'+variant.id;
const automatic=automaticSpec(variant,t,family);
let spec=map.has(key)?{...automatic,...map.get(key)}:automatic;
const groupValue=String(t.dataset.productType||'').trim().toLowerCase().replace(/\s+/g,' ').replace(/\bdept\b/g,'depth').replace(/gauges$/,'gauge');
const typeGroup=/^(digital thickness|dial thickness|dial snap|digital depth|dial depth) gauge$/.test(groupValue)?groupValue:'';
const group=typeGroup||String(t.dataset.gaugeGroup||'').trim().toLowerCase().replace(/\s+/g,' ').replace(/gauges$/,'gauge');
const groups={'digital thickness gauge':['thickness','Digital'],'dial thickness gauge':['thickness','Dial'],'dial snap gauge':['snap','Dial'],'digital depth gauge':['depth','Digital'],'dial depth gauge':['depth','Dial']};
if(group) {
const target=groups[group];
if(!target || target[0]!==family) {found.delete(key);continue;}
spec={...spec,sku:variant.sku,family:target[0],readout:target[1],brand:t.dataset.vendor||spec?.brand||'',description:spec?.description || automaticSpec(variant,t,target[0])?.description || 'Standard'};
}
if(!spec)continue;
else spec={...spec};
for(const field of ['description','range','throat','resolution','accuracy','force','base','stroke','parallelism','indicator']) {
const value=t.dataset['gauge'+field[0].toUpperCase()+field.slice(1)];
if(value && value.trim())spec[field]=field==='description'?value.trim():canonical(value);
}
spec.units=units(spec);
found.set(key,{...spec,price:Number(variant.price),comparePrice:Number(variant.compare_at_price),variantId:variant.id,template:t});
}
}
return Number(feed.dataset.pages)||1;
}
async function workers(tasks) {
let index=0;
async function worker(){while(index<tasks.length){const task=tasks[index++];await task();status.textContent='Loading '+title[family].toLowerCase()+'… '+found.size+' gauges found.';}}
await Promise.all(Array.from({length:Math.min(3,tasks.length)},worker));
}
const query={thickness:'"thickness"',snap:'"snap gauge"',depth:'"depth gauge"'}[family];
const typeNames={depth:['Dial depth gauges','Dial depth gauge','Dial dept gauges','Digital depth gauges','Digital depth gauge'],thickness:['Dial thickness gauges','Dial thickness gauge','Digital thickness gauges','Digital thickness gauge'],snap:['Dial snap gauges','Dial snap gauge']}[family];
const combinedQuery=query+' OR '+typeNames.map(name=>'product_type:"'+name+'"').join(' OR ');
const pages=await fetchPage(combinedQuery,1);
await workers(Array.from({length:pages-1},(_,i)=>()=>fetchPage(combinedQuery,i+2)));
const pending=master.filter(r=>!found.has(norm(r.sku)));
await workers(pending.map(r=>async()=>{const total=await fetchPage(r.sku,1);for(let p=2;p<=total;p++)await fetchPage(r.sku,p);}));
const manualPages=await fetchPage('',1,true);
await workers(Array.from({length:manualPages-1},(_,i)=>()=>fetchPage('',i+2,true)));
const savedTypes=JSON.parse(document.querySelector('[data-mqs-product-types]')?.dataset.mqsProductTypes||'[]');
const directTypes=savedTypes.filter(t=>{
 const group=String(t).trim().toLowerCase().replace(/\s+/g,' ').replace(/\bdept\b/g,'depth').replace(/gauges$/,'gauge');
 return typeNames.some(name=>name.toLowerCase().replace(/gauges$/,'gauge')===group);
});
await workers(directTypes.map(type=>async()=>{
 const total=await fetchPage('',1,false,false,type);
 for(let page=2;page<=total;page++)await fetchPage('',page,false,false,type);
}));
const groupPages=await fetchPage('',1,false,true);
await workers(Array.from({length:groupPages-1},(_,i)=>()=>fetchPage('',i+2,false,true)));
all=[...found.values()];
status.hidden=true;
filters.hidden=false;render();
} catch(error) {status.textContent='Gauge filters could not load. Please retry.';retry.hidden=false;count.textContent='';grid.replaceChildren();}
finally {running=false;}
}
sort.addEventListener('change',()=>{page=1;render();});retry.addEventListener('click',load);await load();
}
document.querySelectorAll('[data-mqsg]').forEach(init);
})();
